import Head from "next/head";
import Image from "next/image";
import * as S from "./Photos.styles";
import images from "./images";

export default function Photos() {
  return (
    <>
      <Head>
        <meta
          name="description"
          property="og:description"
          content="Photos of David and Chloë together"
        />
        <title>Photos • David &amp; Chloë</title>
      </Head>

      <S.Container>
        {/* <p>Photos</p> */}
        <S.Gallery>
          {images.map((img) => {
            return (
              <S.ImageContainer key={img.id}>
                <Image
                  src={img.path}
                  alt="Picture of David and Chloë"
                  width={img.width}
                  height={img.height}
                  loading="lazy"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              </S.ImageContainer>
            );
          })}
        </S.Gallery>
      </S.Container>
    </>
  );
}
